import { useI18n } from 'vue-i18n';
import { getRelativeUrl } from '@/utils/url';
export default {
  setup() {
    const {
      t
    } = useI18n({
      useScope: 'global'
    });
    return {
      t,
      getRelativeUrl
    };
  }
};